<template>
  <div>
    <div v-if="didConnect">
      <div style="padding:8px;background:#2ecc71;color:#FFF;border-radius:4px;margin-bottom:15px;">
        Du är nu ansluten till WiFi-nätverket {{ currentSSID }}. Glöm inte att starta om Bridgen om du drar ut nätverkssladden.
      </div>
    </div>
    
    <div v-if="error.length">
      <div style="padding:8px;background:#e74c3c;color:#FFF;border-radius:4px;margin-bottom:15px;">
        <span v-if="error === 'No lease'">Lyckades inte ansluta till WiFi-nätverket, fick ingen IP-adress</span>
        <span v-else>{{ error }}</span>
      </div>
    </div>


    <h3>WiFi<span v-if="$root.data.info.wifiStatus.connected"> (ansluten till {{ $root.data.info.wifiStatus.ssid }})</span></h3>
    <p>Nedanför ser du alla WiFi-nätverk som Bridgen hittade, tryck på ett nätverk för att ansluta. Om du har ett mesh-system hemma kommer Bridgen att välja det nätverk med bäst signalstyrka. Du måste <i>starta om</i> Bridgen efter, utan nätverkskabel, för att den skall använda WiFi-anslutningen.</p>

    <div style="padding-left:45%;padding-top:1em;" v-if="loading">
      <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
    </div>

    <table v-if="!loading">
      <thead>
        <tr>
          <th>Name</th>
          <th colspan="2">Frekvens</th>
        </tr>
      </thead>

      <tbody>
        <tr class="nohover" v-for="(value, key) in wifis" @click="connect(key)">
          <td width="500">{{ key }}</td>
          <td>{{ value.frequency }} GHz</td>
          <td align="right">
            <span v-if="connectingTo === value.ssid">Ansluter...</span>
            <span v-else-if="currentSSID !== value.ssid">Anslut</span>
            <span v-else><span style="color:#c0392b;">Koppla från</span></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { HalfCircleSpinner } from 'epic-spinners'

  export default {
    name: 'installningar_wifi',
    components: {
      HalfCircleSpinner
    },
    data () {
      return {
        wifis: {},
        loading:true,
        didConnect: false,
        connectingTo: '',
        error: '',
        tempSSID: ''
      }
    },
    async created () {
      const json = (await HTTP.get('wifi')).data

      let list = {}

      json
      .filter(item => 'ssid' in item && item.ssid.length > 0)
      .forEach(network => {     
        const { ssid, rssi } = network
        
        network.frequency = network.frequency.slice(0, 3)
        
        // Om vi inte har nätverket i listan redan så lägger vi till det
        if (!(ssid in list)) {
          list[ssid] = network
        }
        else {
          // Om nuvarande rssi som vi loopar är större (högre) än det
          // tidigare sparade värdet så ersätter vi raden, detta gör att vi
          // bara kommer ta det nätverket med bäst rssi.
          if (rssi > list[ssid].rssi)
            list[ssid] = network
        }
      })

      this.wifis = list
      this.loading = false
    },
    methods: {
      async connect (ssid) {
        if (ssid === this.currentSSID) {
          this.disconnect()
          return
        }
        
        const password = prompt('Input password for ' + ssid)

        if (password.length >= 8) {
          this.connectingTo = ssid

          const json = (await HTTP.post('wifi', {
            ssid: ssid,
            password: password
          })).data

          if (json.status === 'OK') {
            this.$root.data.info.wifiStatus.connected = true
            this.tempSSID = ssid
            this.didConnect = true
            this.connectingTo = ''
          }
          else {
            this.error = json.message
            this.connectingTo = ''
          }
        }
      },
      
      disconnect () {
        if (confirm('Är du säker? Om nätverkskabeln inte är inkopplad kommer du inte att komma åt din Bridge')) {
          HTTP.delete('wifi')
          this.$root.data.info.wifiStatus.connected = false
          this.$root.data.info.wifiStatus.ssid = ''
        }
      }
    },
    computed: {
      currentSSID () {
        if (this.$root.data.info.wifiStatus.ssid)
          return this.$root.data.info.wifiStatus.ssid
        return this.tempSSID
      }
    },
    destroyed () {}
  }
</script>

<style>
  tbody tr:hover {
    background:#fafafa;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/installningar_wifi.vue